<div mat-dialog-title class="modal-header">
  <div style="width: calc(100% - 40px)">
    <div class="css-infwte" style="float: left;padding-right: 20px;">
      <h2 class="css-1ihths2">Formulaire de commande</h2>
      <h6 class="css-1y9swrq">Merci d'inscrire les coordonnées de la personne en charge de la saisie du dossier de
        demande
        de certificat</h6>
    </div>

    <div class="css-1k5igkc2" style="float: right;margin-right: 7px;">
      <div class="css-avcxwc"><h5
        class="css-1cnr62i">Montant TTC</h5></div>
      <div class=""><h3
        class="css-1d69r2e">{{finalPriceHt() + (finalPriceHt() * 0.2)}} € </h3></div>
    </div>
  </div>


  <button mat-icon-button mat-dialog-close aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>

</div>

<div class="modal-content" style="padding: 5px 16px 0;">

  <div class="css-1la58h2"><h2
    class="css-m9esz0">Récapitulatif</h2>
    <hr>
    <div class="css-s2efhj">
      <table class="css-1wx7rec">
        <tbody class="css-16xo75i">
        <tr class="css-1fsomi2">
          <td class="css-1w6hdiq">
            <div class="css-0"><h6 class="css-ryxypm">{{product.name}}</h6></div>
            <div class="css-0"><span class="css-1044bew">{{product.reference}}</span>
            </div>
          </td>
          <td class="css-9jqui9">
            <div class="css-xi606m">
              <mat-form-field appearance="outline" class="custom-placeholder input-quantity">
                <input matInput type="number" class="css-m3onv0" style="padding: 0 .05em 3px 0.75em;"
                       [(ngModel)]="quantity" (input)="enforceMaxLength($event)" pattern="\d*"
                       maxlength="2" min="1" max="99">
              </mat-form-field>
              <!--              <input type="number" class="css-m3onv0" value="1" min="1" max="99" width="60px;"></input></div>-->
            </div>
          </td>
          <td class="css-9jqui9 css-9jqui9-last"><p
            class="css-1el21yk">{{priceDecideurHt * quantity}} € HT</p></td>
        </tr>
        <tr *ngFor="let selectedOptions of getSelectedOptions()" class="css-1fsomi2">

          <td class="css-1w6hdiq">
            <div class="css-0"><h6 class="css-ryxypm">{{selectedOptions.name}}</h6></div>
            <div class="css-0"><span class="css-1044bew">{{selectedOptions.reference}}</span>
            </div>
          </td>
          <td class="css-9jqui9">
            <div class="css-xi606m">
            </div>
          </td>
          <td class="css-9jqui9 css-9jqui9-last"><p
            class="css-1el21yk">{{(selectedOptions.price) * quantity}} € HT</p></td>

        </tr>


        </tbody>
      </table>
      <div class="css-1k5igkc">
        <div class="css-avcxwc"><h5
          class="css-1cnr62i">Montant HT</h5></div>
        <div class="css-yp9ue7"><h3
          class="css-1d69r2e">{{finalPriceHt()}} € </h3></div>
      </div>

      <div class="css-1k5igkc">
        <div class="css-avcxwc"><h5
          class="css-1cnr62i">Montant TTC</h5></div>
        <div class="css-yp9ue7"><h3
          class="css-1d69r2e">{{finalPriceHt() + (finalPriceHt() * (vat/100))}} € </h3></div>
      </div>
      <div class="css-s2efhj"><label class="css-1bc0zge">
        <span><mat-checkbox class="example-margin" (change)="cgvDetail($event)" [(ngModel)]="isAccepted">J'ai lu et accepte les CGV</mat-checkbox></span>
      </label></div>
    </div>
  </div>


  <div class="wizard" style="height: 100%; background: #fff; margin-top: 10px;">
    <mat-horizontal-stepper linear #stepper style="padding: 0 32px;">
      <mat-step [stepControl]="isStepValid()" [editable]="isEditable">

        <div style="display:inline-block;margin-bottom: 20px;">
          <h2 class="css-m9esz0" style="padding-left: 0 !important;">Identification client</h2>


          <form [formGroup]="userInfoFormGroup">
            <ng-template matStepLabel>Identification client</ng-template>
            <div>

              <div class="row-fluid">
                <div class="col-sd-2 col-md-2" style="float: left; padding-left: 10px;">
                  <label
                    [ngClass]="{'label-error': userInfoFormGroup.get('gender').invalid && userInfoFormGroup.get('gender').touched}">Civilité
                    *</label>
                  <mat-form-field appearance="outline" class="custom-placeholder">
                    <!--                  <mat-label>Civilité *</mat-label>-->
                    <!--                  <input matInput formControlName="gender" placeholder="Civilité" required>-->
                    <mat-select formControlName="gender">
                      <mat-option *ngFor="let option of genders" [value]="option">
                        {{ option }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-sd-5 col-md-5" style="float: left; padding-left: 10px;">

                  <label
                    [ngClass]="{'label-error': userInfoFormGroup.get('firstName').invalid && userInfoFormGroup.get('firstName').touched}">Prénom
                    *</label>
                  <mat-form-field appearance="outline" class="custom-placeholder">
                    <input matInput formControlName="firstName" placeholder="Prénom" required>
                  </mat-form-field>
                </div>


                <div class="col-sd-5 col-md-5" style="float: left; padding-left: 10px;">
                  <label
                    [ngClass]="{'label-error': userInfoFormGroup.get('lastName').invalid && userInfoFormGroup.get('lastName').touched}">Nom
                    *</label>
                  <mat-form-field appearance="outline" class="custom-placeholder">
                    <input matInput formControlName="lastName" placeholder="Nom" required>
                  </mat-form-field>
                </div>


              </div>

              <div class="row-fluid">

                <div class="col-sd-6 col-md-6" style="float: left; padding-left: 10px;">
                  <label
                    [ngClass]="{'label-error': userInfoFormGroup.get('email').invalid && userInfoFormGroup.get('email').touched}">Email
                    *</label>
                  <mat-form-field appearance="outline" class="custom-placeholder">
                    <input type="email" matInput formControlName="email" placeholder="Email" required>
                    <mat-error *ngIf="userInfoFormGroup.get('email').hasError('required')">
                      L'email est requis.
                    </mat-error>
                    <mat-error *ngIf="userInfoFormGroup.get('email').hasError('email')">
                      L'email n'est pas valide.
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-sd-6 col-md-6" style="float: left; padding-left: 10px;">
                  <label
                    [ngClass]="{'label-error': userInfoFormGroup.get('emailVerification').invalid && userInfoFormGroup.get('emailVerification').touched}">Vérification
                    email *</label>
                  <mat-form-field appearance="outline" class="custom-placeholder">
                    <input type="email" matInput formControlName="emailVerification" placeholder="Vérification email"
                           required>
                    <mat-error *ngIf="userInfoFormGroup.get('emailVerification').hasError('required')">
                      La vérification de l'email est requise.
                    </mat-error>
                    <mat-error *ngIf="userInfoFormGroup.get('emailVerification').hasError('email')">
                      L'email de vérification n'est pas valide.
                    </mat-error>
                    <mat-error
                      *ngIf="userInfoFormGroup.get('emailVerification').value !== userInfoFormGroup.get('email').value">
                      Les emails ne correspondent pas.
                    </mat-error>
                  </mat-form-field>
                </div>


              </div>

              <div class="row-fluid">

                <div class="col-sd-12 col-md-12" style="float: left; padding-left: 10px;">
                  <label
                    [ngClass]="{'label-error': userInfoFormGroup.get('phone').invalid && userInfoFormGroup.get('phone').touched}">Téléphone
                    *</label>
                  <mat-form-field appearance="outline" class="custom-placeholder">
                    <input matInput formControlName="phone" placeholder="Téléphone" required>
                  </mat-form-field>
                </div>

                <div class="col-sd-12 col-md-12" style="float: left; padding-left: 10px;">
                  <label
                    [ngClass]="{'label-error': userInfoFormGroup.get('country').invalid && userInfoFormGroup.get('country').touched}">Pays
                    *</label>
                  <mat-form-field appearance="outline" class="custom-placeholder">
                    <input matInput formControlName="country" placeholder="Pays" required>
                  </mat-form-field>
                </div>

                <div class="col-sd-12 col-md-12" style="float: left; padding-left: 10px;">
                  <label
                    [ngClass]="{'label-error': userInfoFormGroup.get('companyName').invalid && userInfoFormGroup.get('companyName').touched}">Raison
                    sociale *</label>
                  <mat-form-field appearance="outline" class="custom-placeholder">
                    <input matInput formControlName="companyName" placeholder="Raison sociale" required>
                  </mat-form-field>

                </div>


                <div class="col-sd-6 col-md-6" style="float: left; padding-left: 10px;">
                  <label
                    [ngClass]="{'label-error': userInfoFormGroup.get('siret').invalid && userInfoFormGroup.get('siret').touched}">Siret
                    *</label>
                  <mat-form-field appearance="outline" class="custom-placeholder">
                    <input matInput formControlName="siret" placeholder="Siret" pattern="^\d{1,14}$" minlength="14"
                           maxlength="14" required>

                  </mat-form-field>
                </div>

                <div class="col-sd-6 col-md-6" style="float: left; padding-left: 10px;">
                  <label
                    [ngClass]="{'label-error': userInfoFormGroup.get('address').invalid && userInfoFormGroup.get('address').touched}">Adresse
                    *</label>
                  <mat-form-field appearance="outline" class="custom-placeholder">
                    <input matInput formControlName="address" placeholder="Adresse" required>
                  </mat-form-field>

                </div>

                <div class="col-sd-6 col-md-6" style="float: left; padding-left: 10px;">
                  <label
                    [ngClass]="{'label-error': userInfoFormGroup.get('postalCode').invalid && userInfoFormGroup.get('postalCode').touched}">Code
                    postal *</label>
                  <mat-form-field appearance="outline" class="custom-placeholder">
                    <input matInput formControlName="postalCode" placeholder="Code postal" required>
                  </mat-form-field>
                </div>

                <div class="col-sd-6 col-md-6" style="float: left; padding-left: 10px;">
                  <label
                    [ngClass]="{'label-error': userInfoFormSubmitted && userInfoFormGroup.get('city').invalid && userInfoFormGroup.get('city').touched}">Ville
                    *</label>
                  <mat-form-field appearance="outline" class="custom-placeholder">
                    <input matInput formControlName="city" placeholder="Ville" required>
                  </mat-form-field>

                </div>


                <div class="col-sd-6 col-md-6" style="float: left; padding-left: 10px;">
                  <div class="css-s2efhj"><label class="css-1bc0zge">
                  <span><mat-checkbox class="example-margin" formControlName="billingInfo" data-bs-toggle="collapse"
                                      data-bs-target="#collapseBillingInfo" aria-expanded="false"
                                      aria-controls="collapseBillingInfo"></mat-checkbox></span>
                    <span class="css-pqfpo8">Les informations de facturation sont différentes</span></label>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <!--        Formulaire de facturation-->
        <div class="collapse" id="collapseBillingInfo" style="">
          <h2 class="css-m9esz0" style="padding-left: 0 !important;">Facturation</h2>
          <form [formGroup]="billingInfoFormGroup">
            <ng-template matStepLabel>Identification client</ng-template>
            <div>

              <div class="row-fluid">
                <div class="col-sd-2 col-md-2" style="float: left; padding-left: 10px;">
                  <label
                    [ngClass]="{'label-error': billingInfoFormGroup.get('gender').invalid && billingInfoFormGroup.get('gender').touched}">Civilité
                    *</label>
                  <mat-form-field appearance="outline" class="custom-placeholder">
                    <!--                  <mat-label>Civilité *</mat-label>-->
                    <!--                  <input matInput formControlName="gender" placeholder="Civilité" required>-->
                    <mat-select formControlName="gender">
                      <mat-option *ngFor="let option of genders" [value]="option">
                        {{ option }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-sd-5 col-md-5" style="float: left; padding-left: 10px;">

                  <label
                    [ngClass]="{'label-error': billingInfoFormGroup.get('firstName').invalid && billingInfoFormGroup.get('firstName').touched}">Prénom
                    *</label>
                  <mat-form-field appearance="outline" class="custom-placeholder">
                    <input matInput formControlName="firstName" placeholder="Prénom" required>
                  </mat-form-field>
                </div>


                <div class="col-sd-5 col-md-5" style="float: left; padding-left: 10px;">
                  <label
                    [ngClass]="{'label-error': billingInfoFormGroup.get('lastName').invalid && billingInfoFormGroup.get('lastName').touched}">Nom
                    *</label>
                  <mat-form-field appearance="outline" class="custom-placeholder">
                    <input matInput formControlName="lastName" placeholder="Nom" required>
                  </mat-form-field>
                </div>


              </div>

              <div class="row-fluid">

                <div class="col-sd-6 col-md-6" style="float: left; padding-left: 10px;">
                  <label
                    [ngClass]="{'label-error': billingInfoFormGroup.get('email').invalid && billingInfoFormGroup.get('email').touched}">Email
                    *</label>
                  <mat-form-field appearance="outline" class="custom-placeholder">
                    <input type="email" matInput formControlName="email" placeholder="Email" required>
                    <mat-error *ngIf="billingInfoFormGroup.get('email').hasError('required')">
                      L'email est requis.
                    </mat-error>
                    <mat-error *ngIf="billingInfoFormGroup.get('email').hasError('email')">
                      L'email n'est pas valide.
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-sd-6 col-md-6" style="float: left; padding-left: 10px;">
                  <label
                    [ngClass]="{'label-error': billingInfoFormGroup.get('emailVerification').invalid && billingInfoFormGroup.get('emailVerification').touched}">Vérification
                    email *</label>
                  <mat-form-field appearance="outline" class="custom-placeholder">
                    <input type="email" matInput formControlName="emailVerification" placeholder="Vérification email"
                           required>
                    <mat-error *ngIf="billingInfoFormGroup.get('emailVerification').hasError('required')">
                      La vérification de l'email est requise.
                    </mat-error>
                    <mat-error *ngIf="billingInfoFormGroup.get('emailVerification').hasError('email')">
                      L'email de vérification n'est pas valide.
                    </mat-error>
                    <mat-error
                      *ngIf="billingInfoFormGroup.get('emailVerification').value !== billingInfoFormGroup.get('email').value">
                      Les emails ne correspondent pas.
                    </mat-error>
                  </mat-form-field>
                </div>


              </div>

              <div class="row-fluid">

                <div class="col-sd-12 col-md-12" style="float: left; padding-left: 10px;">
                  <label
                    [ngClass]="{'label-error': billingInfoFormGroup.get('phone').invalid && billingInfoFormGroup.get('phone').touched}">Téléphone
                    *</label>
                  <mat-form-field appearance="outline" class="custom-placeholder">
                    <input matInput formControlName="phone" placeholder="Téléphone" required>
                  </mat-form-field>
                </div>

                <div class="col-sd-12 col-md-12" style="float: left; padding-left: 10px;">
                  <label
                    [ngClass]="{'label-error': billingInfoFormGroup.get('country').invalid && billingInfoFormGroup.get('country').touched}">Pays
                    *</label>
                  <mat-form-field appearance="outline" class="custom-placeholder">
                    <input matInput formControlName="country" placeholder="Pays" disabled required>
                  </mat-form-field>
                </div>

                <div class="col-sd-12 col-md-12" style="float: left; padding-left: 10px;">
                  <label
                    [ngClass]="{'label-error': billingInfoFormGroup.get('companyName').invalid && billingInfoFormGroup.get('companyName').touched}">Raison
                    sociale *</label>
                  <mat-form-field appearance="outline" class="custom-placeholder">
                    <input matInput formControlName="companyName" placeholder="Raison sociale" required>
                  </mat-form-field>

                </div>


                <div class="col-sd-6 col-md-6" style="float: left; padding-left: 10px;">
                  <label
                    [ngClass]="{'label-error': billingInfoFormGroup.get('siret').invalid && billingInfoFormGroup.get('siret').touched}">Siret
                    *</label>
                  <mat-form-field appearance="outline" class="custom-placeholder">
                    <input matInput formControlName="siret" placeholder="Siret" required>

                  </mat-form-field>
                </div>

                <div class="col-sd-6 col-md-6" style="float: left; padding-left: 10px;">
                  <label
                    [ngClass]="{'label-error': billingInfoFormGroup.get('address').invalid && billingInfoFormGroup.get('address').touched}">Adresse
                    *</label>
                  <mat-form-field appearance="outline" class="custom-placeholder">
                    <input matInput formControlName="address" placeholder="Adresse" required>
                  </mat-form-field>

                </div>

                <div class="col-sd-6 col-md-6" style="float: left; padding-left: 10px;">
                  <label
                    [ngClass]="{'label-error': billingInfoFormGroup.get('postalCode').invalid && billingInfoFormGroup.get('postalCode').touched}">Code
                    postal *</label>
                  <mat-form-field appearance="outline" class="custom-placeholder">
                    <input matInput formControlName="postalCode" placeholder="Code postal" required>
                  </mat-form-field>
                </div>

                <div class="col-sd-6 col-md-6" style="float: left; padding-left: 10px;">
                  <label
                    [ngClass]="{'label-error': billingInfoFormGroup.get('city').invalid && billingInfoFormGroup.get('city').touched}">Ville
                    *</label>
                  <mat-form-field appearance="outline" class="custom-placeholder">
                    <input matInput formControlName="city" placeholder="Ville" required>
                  </mat-form-field>

                </div>
              </div>


            </div>
          </form>
        </div> <!-- formulaire de facturation-->

<!--        <div class="row-fluid">-->
<!--          <div class="col-sd-12 col-md-12" style="float: left; padding-left: 10px;margin-top: 20px;">-->
<!--            <button matStepperNext class="btn-bleu" (click)="onSubmit()"-->
<!--                    [disabled]="(this.userInfoFormGroup.invalid && !userInfoFormGroup.get('billingInfo').value) || (this.userInfoFormGroup.valid && userInfoFormGroup.get('billingInfo').value && this.billingInfoFormGroup.invalid)"-->
<!--                    style="float: right;">Continuer-->
<!--            </button>-->
<!--          </div>-->
<!--        </div>-->

      </mat-step>


      <!--      <mat-step [stepControl]="optionsFormGroup" [editable]="isEditable">-->
      <mat-step [stepControl]="">
        <div style="margin-bottom: 20px;">
          <h2 class="css-m9esz0" style="padding-left: 0 !important;">Options</h2>
          <ng-template matStepLabel>Options</ng-template>
          <div>
            <div *ngFor="let option of product.options_products" class="row-fluid">
              <!--                Option traitement Express-->

              <div class="css-c4sutr">
                <div class="css-hboir5">
                  <div class="css-8atqhb">
                    <div class="css-1403iiz">
                      <div class="css-16ontbv">
                        <div class="css-1pxxj52"><label
                          class="css-f03jx4"><span style="float: left;margin-right: 10px;">
                    <mat-checkbox class="example-margin" [(ngModel)]="selectedOptions[option.reference]"
                                  (ngModelChange)="showSelectedOptions(option)"></mat-checkbox>
                    <span class="css-ex1lad"></span></span><span class="css-1s9hx13"><div
                          class="css-0"><h6 class="css-xl024c">{{option.name}}</h6><p
                          class="css-2mm59z">{{option.description}}</p></div></span></label>
                        </div>
                        <div class="css-yp9ue7">
                          <div class="css-1jc6j8w"><h1 class="css-ytld2i">
                            {{option.price}}€</h1><h6 class="css-1rh9d57">HT/certif</h6></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
<!--        <div class="row-fluid">-->
<!--          <div class="col-sd-12 col-md-12" style="float: left; padding-left: 10px;margin-top: 20px;">-->

<!--            <button matStepperNext class="btn-bleu" (click)="onSubmit()"-->
<!--                    style="float: right;">Continuer-->
<!--            </button>-->
<!--            <button matStepperPrevious class="btn-bleu"-->
<!--                    style="float: right;">Retour-->
<!--            </button>-->
<!--          </div>-->
<!--        </div>-->
      </mat-step>


      <mat-step>
        <div style="margin-bottom: 20px;">
          <h2 class="css-m9esz0" style="padding-left: 0 !important;">Paiement</h2>
          <form [formGroup]="paymentFormGroup">
            <ng-template matStepLabel>Paiement</ng-template>
            <div>
              <!-- Radio buttons to control the sections -->
              <mat-radio-group aria-label="Select an option" formControlName="paymentOption">
                <div id="accordionExample">

                  <!-- First collapsible - Mandat administratif -->
                  <div *ngIf="administrativeMandateIsAvailable()" class="css-1sl0mb4">
                    <div class="css-16cq4ne">
                      <div class="css-1pxxj52">
                        <label class="css-f03jx4">
                <span class="css-1rksw08">
                  <mat-radio-button value="1" role="button" aria-expanded="false">
                    <span class="css-ex1lad"></span>
                  </mat-radio-button>
                </span>
                          <span class="css-1s9hx13">Mandat administratif</span>
                        </label>
                      </div>
                      <div class="css-yp9ue7">
                        <div class="css-192qrng">
                          <img src="assets/images/mandate.svg" alt="Mandat administratif">
                        </div>
                      </div>

                      <!-- Show content when '1' is selected -->
                      <div *ngIf="paymentFormGroup.get('paymentOption')?.value === '1'" style="width: 100%;">
                        <div class="css-92exc1">
                          <div class="css-i3pbo">
                            <div class="css-feqhe6">
                              <label>Siret</label>
                              <mat-form-field appearance="outline" class="custom-placeholder">
                                <input matInput formControlName="siret" placeholder="Siret" class="css-1svicrf"
                                       required>
                              </mat-form-field>
                            </div>
                          </div>
                          <div class="css-i3pbo">
                            <div class="css-feqhe6">
                              <label>Code service</label>
                              <mat-form-field appearance="outline" class="custom-placeholder">
                                <input matInput formControlName="serviceCode" placeholder="Code service"
                                       class="css-1svicrf" required>
                              </mat-form-field>
                            </div>
                          </div>
                          <div class="css-0">
                            <div class="css-feqhe6">
                              <label>Numéro commande Chorus</label>
                              <mat-form-field appearance="outline" class="custom-placeholder">
                                <input matInput formControlName="ChorusOrderNumber" placeholder="Numéro commande Chorus"
                                       class="css-1svicrf" required>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Second collapsible - Virement à la commande -->
                  <div class="css-1sl0mb4">
                    <div class="css-16cq4ne">
                      <div class="css-1pxxj52">
                        <label class="css-f03jx4">
                <span class="css-1rksw08">
                  <mat-radio-button value="2" role="button" aria-expanded="false">
                    <span class="css-ex1lad"></span>
                  </mat-radio-button>
                </span>
                          <span class="css-1s9hx13">Virement à la commande</span>
                        </label>
                      </div>
                      <div class="css-yp9ue7">
                        <div class="css-192qrng">
                          <img src="assets/images/transfer.svg" alt="Virement">
                        </div>
                      </div>

                      <!-- Show content when '2' is selected -->
                      <div *ngIf="paymentFormGroup.get('paymentOption')?.value === '2'" style="width: 100%;">
                        <div class="css-12fuuxg">
                          <div class="css-1yjvs5a">
                            <h5 class="css-1e1kw9p">Titulaire du compte</h5>
                            <h6 class="css-e2bqao">Merci d'effectuer votre virement sur le compte ci-dessous; veillez à
                              bien indiquer dans votre ordre de virement la référence de la commande concernée</h6>
                            <p class="css-1s4tszz">DOCAPOSTE CERTINOMIS</p>
                            <p class="css-19k13wf">45 BD PAUL VAILLANT COUTURIER, 94200 IVRY-SUR-SEINE</p>
                          </div>
                          <div class="css-i3pbo">
                            <h5 class="css-1e1kw9p">RIB</h5>
                            <table class="css-1wx7rec">
                              <thead class="css-tlte59">
                              <tr class="css-1fsomi2">
                                <th class="css-1udob4s">Code banque</th>
                                <th class="css-1udob4s">Code Guichet</th>
                                <th class="css-1udob4s">Numéro de compte</th>
                                <th class="css-1udob4s">RIB Key</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr class="css-1fsomi2">
                                <td class="css-16t7ywk">30003</td>
                                <td class="css-16t7ywk">03640</td>
                                <td class="css-16t7ywk">00020508424</td>
                                <td class="css-16t7ywk">42</td>
                              </tr>
                              </tbody>
                            </table>
                            <h5 class="css-1e1kw9p">IBAN</h5>
                            <p class="css-19k13wf">FR76 30003 03640 00020508424 42</p>
                            <h5 class="css-1e1kw9p">BIC</h5>
                            <p class="css-19k13wf">SOGEFRPP</p>

                            <h5 class="css-1e1kw9p">Domiciliation</h5>
                            <p class="css-1s4tszz">Société Générale</p>
                            <p class="css-1s4tszz">PARIS RIVE GAUCHE ENTREPRISES</p>


                          </div>
                          <div class="css-0">
                            <label>Référence du virement</label>
                            <mat-form-field appearance="outline" class="custom-placeholder">
                              <input matInput formControlName="TransferReference" placeholder="Référence du virement"
                                     required>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Third collapsible - Chèque à la commande -->
                  <div class="css-1sl0mb4">
                    <div class="css-16cq4ne">
                      <div class="css-1pxxj52">
                        <label class="css-f03jx4">
                <span class="css-1rksw08">
                  <mat-radio-button value="3" role="button" aria-expanded="false">
                    <span class="css-ex1lad"></span>
                  </mat-radio-button>
                </span>
                          <span class="css-1s9hx13">Chèque à la commande</span>
                        </label>
                      </div>
                      <div class="css-yp9ue7">
                        <div class="css-192qrng">
                          <img src="assets/images/check.svg" alt="Chèque à la commande">
                        </div>
                      </div>

                      <!-- Show content when '3' is selected -->
                      <div *ngIf="paymentFormGroup.get('paymentOption')?.value === '3'" style="width: 100%;">
                        <div class="css-92exc1">
                          <div class="css-i3pbo">
                            <label>Numéro de chèque</label>
                            <mat-form-field appearance="outline" class="custom-placeholder">
                              <input matInput formControlName="checkNumber" placeholder="Numéro de chèque"
                                     class="css-1svicrf" required>
                            </mat-form-field>
                          </div>
                          <div class="css-0">
                            <label>Banque</label>
                            <mat-form-field appearance="outline" class="custom-placeholder">
                              <input matInput formControlName="bankName" placeholder="Banque" class="css-1svicrf"
                                     required>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </mat-radio-group>
            </div>
          </form>
        </div>
      </mat-step>

    </mat-horizontal-stepper>

  </div>

</div>

<div mat-dialog-actions class="modal-footer" style="justify-content: space-between;">
  <div>
    <button type="button" class="btn-transparent" mat-dialog-close style="margin-right: 10px;">Annuler</button>
    <button class="btn-bleu" (click)="stepper.reset()">Réinitialiser
    </button>
  </div>
  <div>
    <button class="btn-transparent" style="margin-right: 10px;" (click)="stepper.previous()"
            [disabled]="stepper.selectedIndex === 0"><span class="css-pt151r">
                  <mat-icon>arrow_back</mat-icon></span>Retour
    </button>
    <button *ngIf="!(stepper.selectedIndex === stepper.steps.length - 1)" class="btn-bleu" (click)="stepper.next()"
            [disabled]="(this.userInfoFormGroup.invalid && !userInfoFormGroup.get('billingInfo').value) || (userInfoFormGroup.get('billingInfo').value && this.billingInfoFormGroup.invalid) || stepper.selectedIndex === stepper.steps.length - 1">
      Suivant <span class="css-pt151d">
                  <mat-icon>arrow_forward</mat-icon></span></button>

    <button *ngIf="stepper.selectedIndex === stepper.steps.length - 1" mat-dialog-close="confirm" class="btn-bleu" (click)="this.SendCertificateorder()"
            [disabled]="!isFormValid() || !isPaymentValid() || !isAccepted">
      Commander <span class="css-pt151d"></span></button>
  </div>

</div>
